<div *ngIf="zeroResultInfo"
  class="zero-result-container"
  fxLayout="row"
  fxLayoutAlign="center center"
  [fxLayoutGap]="isMobileOrTablet ? '16px' : '32px'">

  <img *ngIf="zeroResultInfo.imageUrl as imageUrl"
    class="zero-result-container__image"
    [src]="imageUrl" alt="zero-result"/>

  <div
    class="zero-result-container__text"
    fxLayout="column"
    fxLayoutAlign="start"
    [ngStyle]="zeroResultInfo.imageUrl ? {'text-align': 'start'} : {'text-align': 'center'}">
    <p class="zero-result-container__text__title">{{zeroResultInfo.title | translate}}</p>
    <p class="zero-result-container__text__subtitle">{{zeroResultInfo.subTitle | translate}}</p>
  </div>
</div>
